<template>
  <section class="step1-form" :style="{minHeight:(screenHeight-85)+'px'}">
    <div class="step-form__step-num">2/5</div>
    <div v-if="Number(userInfo.crmCustomerType) === 1">
      <div class="step-form__main">
        <h1 class="step-form__title">个人信息确认</h1>
        <el-row :gutter="0">
          <el-col :span="16">
            <el-form class="step-form__form" :label-width="'50%'" :model="step2Form" :rules="rules" ref="step2Form">
              <el-form-item label="真实姓名" prop="realName">
                <el-input type="text" placeholder="请输入真实姓名" :disabled="isEditable === 1"
                          v-model="step2Form.realName"></el-input>
              </el-form-item>
              <el-form-item label="身份证号" prop="IDCardNum">
                <el-input type="text" placeholder="请输入身份证号" :disabled="isEditable === 1"
                          v-model="step2Form.IDCardNum"></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="cellphone">
                <el-input type="tel" placeholder="请输入手机号码" :maxlength="11" :disabled="isEditable === 1"
                          v-model="step2Form.cellphone"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <div class="step-form__btn-container">
          <button class="step-form__btn-prev" @click="goBack">上一步</button>
          <button class="step-form__btn-next" @click="submitForm">下一步</button>
        </div>
      </div>
    </div>

    <div v-if="Number(userInfo.crmCustomerType) === 2">
      <div class="step-form__main">
        <h1 class="step-form__title">企业信息确认</h1>
        <el-row :gutter="0">
          <el-col :span="16">
            <el-form class="step-form__form" :label-width="'50%'" :model="step2FormEnterprise" :rules="rules"
                     ref="step2Form">
              <el-form-item label="客户名称" :required="true" prop="customerName">
                <el-input type="text" placeholder="请输入客户名称" :disabled="isEditable === 1"
                          v-model="step2FormEnterprise.customerName"></el-input>
              </el-form-item>
              <el-form-item label="营业执照号" :required="true" prop="enterpriseNumber">
                <el-input type="text" placeholder="请输入营业执照号" :disabled="isEditable === 1"
                          v-model="step2FormEnterprise.enterpriseNumber"></el-input>
              </el-form-item>
              <el-form-item label="股东人数" prop="enterprisePartnerNumber">
                <el-input type="text" placeholder="请输入股东人数"
                          v-model="step2FormEnterprise.enterprisePartnerNumber"></el-input>
              </el-form-item>
              <el-form-item label="注册地址" prop="enterpriseRegAddr">
                <el-input type="textarea" placeholder="请输入注册地址" :maxlength='100' resize="none" :rows="2"
                          v-model="step2FormEnterprise.enterpriseRegAddr"></el-input>
              </el-form-item>
              <el-form-item label="企业性质" prop="enterpriseType">
                <el-select v-model="step2FormEnterprise.enterpriseType" placeholder="请选择">
                  <el-option
                    v-for="item in step2FormEnterprise.enterpriseTypeArray"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="注册资金" prop="enterpriseRegMoney">
                <el-input type="text" placeholder="请输入注册资金"
                          v-model="step2FormEnterprise.enterpriseRegMoney"></el-input>
              </el-form-item>
              <!-- <el-form-item label="注册人类型" :required="true" prop="userType">
                <el-radio-group v-model="step2FormEnterprise.userType" :disabled="isEditable === 1">
                  <el-radio :label="2">法定代表人注册</el-radio>
                  <el-radio :label="1">代理人注册</el-radio>
                </el-radio-group>
              </el-form-item> -->
              <el-form-item :label="Number(step2FormEnterprise.userType) === 2 ? '法定代表人' : '代理人'" :required="true" prop="enterpriseLegalUser">
                <el-input type="text" :placeholder="Number(step2FormEnterprise.userType) === 2 ? '请输入法定代表人' : '请输入代理人'" :disabled="isEditable === 1"
                          v-model="step2FormEnterprise.enterpriseLegalUser"></el-input>
              </el-form-item>
              <el-form-item :label="Number(step2FormEnterprise.userType) === 2 ? '法定代表人身份证号' : '代理人身份证号'" :required="true" prop="enterpriseLegalIdNo">
                <el-input type="text" :placeholder="Number(step2FormEnterprise.userType) === 2 ? '请输入法定代表人身份证号' : '请输入代理人身份证号'" :disabled="isEditable === 1"
                          v-model="step2FormEnterprise.enterpriseLegalIdNo"></el-input>
              </el-form-item>
              <el-form-item :label="Number(step2FormEnterprise.userType) === 2 ? '法定代表人联系电话':'代理人联系电话'" :required="true" prop="enterpriseLegalUserPhone">
                <el-input type="tel" :placeholder="Number(step2FormEnterprise.userType) === 2 ?'请输入法定代表人联系电话':'请输入法定代表人联系电话'" :disabled="isEditable === 1" :maxlength="11"
                          v-model="step2FormEnterprise.enterpriseLegalUserPhone"></el-input>
              </el-form-item>
              <el-form-item label="企业注册类型" :required="true" prop="registrationType">
                <el-radio-group v-model="step2FormEnterprise.registrationType" :disabled="isEditable === 1">
                  <el-radio :label="0">组织机构代码证号</el-radio>
                  <el-radio :label="1">多证合一</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="Number(step2FormEnterprise.registrationType) === 0?'组织机构代码证号':'社会信用代码号'" :required="true" prop="enterpriseOrganizingNumber">
                <el-input type="text" :placeholder="Number(step2FormEnterprise.registrationType) === 0?'请输入组织机构代码证号':'请输入社会信用代码号'"
                          v-model="step2FormEnterprise.enterpriseOrganizingNumber" :disabled="isEditable === 1"></el-input>
              </el-form-item>
              <el-form-item label="企业规模" prop="enterpriseScale">
                <el-select v-model="step2FormEnterprise.enterpriseScale" placeholder="请选择">
                  <el-option
                    v-for="item in step2FormEnterprise.enterpriseScaleArray"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="国税登记证号" prop="enterpriseNationalNumber">
                <el-input type="text" placeholder="请输入国税登记证号"
                          v-model="step2FormEnterprise.enterpriseNationalNumber"></el-input>
              </el-form-item>
              <el-form-item label="地税登记证号" prop="enterpriseNationalNumber">
                <el-input type="text" placeholder="请输入地税登记证号"
                          v-model="step2FormEnterprise.enterpriseGovernmentNumber"></el-input>
              </el-form-item>
              <el-form-item label="登记机关" prop="enterpriseRegOrgan">
                <el-input type="text" placeholder="请输入登记机关"
                          v-model="step2FormEnterprise.enterpriseRegOrgan"></el-input>
              </el-form-item>
              <el-form-item label="从业人数" prop="enterpriseEmployeeNum">
                <el-input type="text" placeholder="请输入从业人数"
                          v-model="step2FormEnterprise.enterpriseEmployeeNum"></el-input>
              </el-form-item>
              <el-form-item label="经营范围" prop="enterpriseScope">
                <el-input type="textarea" placeholder="请输入经营范围" :maxlength='100' resize="none" :rows="3"
                          v-model="step2FormEnterprise.enterpriseScope"></el-input>
              </el-form-item>
              <el-form-item label="成立背景" prop="enterpriseFoundExplain">
                <el-input type="textarea" placeholder="请输入成立背景" :maxlength='100' resize="none" :rows="6"
                          v-model="step2FormEnterprise.enterpriseFoundExplain"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <div class="step-form__btn-container">
          <button class="step-form__btn-prev" @click="goBack">上一步</button>
          <button class="step-form__btn-next" @click="submitForm">下一步</button>
        </div>
      </div>
    </div>

  </section>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex'
  import * as types from '../../vuex/types'
  import _ from 'lodash'

  // 企业那边如果界面差异变大，则建议分出去另一个组件
  export default {
    data () {
      const assignValidator = (type, trigger = 'blur') => Object.assign({
//        required: true,
        trigger
      }, {
        validator: (rules, value, callback, source, options) => {
          this.$store.dispatch(type, {rules, value, callback, source, options})
        }
      })
      return {
        isSubmitting: false,
        isEditable: '',
        screenHeight: document.body.clientHeight,
        rules: {
          realName: [assignValidator((types.VERIFY_CHN_NAME))],
          IDCardNum: [assignValidator(types.VERIFY_ID_CARD_NUM)],
          cellphone: [assignValidator(types.VERIFY_CELLPHONE)],
          customerName: [{
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('客户名称不能为空'))
              } else {
                callback()
              }
            }
          }],
          enterpriseNumber: [{
            require: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('营业执照号不能为空'))
              } else {
                callback()
              }
            }
          }],
          enterpriseOrganizingNumber: [{
            require: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('证件号码不能为空'))
              } else {
                callback()
              }
            }
          }],
          userType: [{
            require: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择'))
              } else {
                callback()
              }
            }
          }],
          registrationType: [{
            require: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择'))
              } else {
                callback()
              }
            }
          }],
          enterpriseLegalUser: [assignValidator((types.VERIFY_CHN_NAME))],
          enterpriseLegalUserPhone: [assignValidator(types.VERIFY_CELLPHONE)],
          enterpriseLegalIdNo: [assignValidator(types.VERIFY_ID_CARD_NUM)]
        },
        step2Form: {
          realName: '',
          IDCardNum: '',
          cellphone: ''
        },
        step2FormEnterprise: {
          customerName: '',
          enterpriseNumber: '',
          enterprisePartnerNumber: '',
          enterpriseRegAddr: '',
          enterpriseType: '',
          enterpriseRegMoney: '',
          enterpriseLegalUser: '',
          enterpriseLegalIdNo: '',
          enterpriseLegalUserPhone: '',
          enterpriseOrganizingNumber: '',
          enterpriseScale: '',
          enterpriseNationalNumber: '',
          enterpriseGovernmentNumber: '',
          enterpriseRegOrgan: '',
          enterpriseEmployeeNum: '',
          enterpriseScope: '',
          enterpriseFoundExplain: '',
          enterpriseScaleArray: [],
          enterpriseTypeArray: [],
          userType: 1,
          registrationType: 0
        }
      }
    },
    computed: {
      ...mapGetters({
        myInfo: types.GET_MY_INFO,
        userInfo: types.GET_USER
      })
    },
    methods: {
      ...mapActions({
        updatePassword: types.UPDATE_PASSWORD,
        getPersonalInfo: types.GET_PERSONAL_INFO,
        getEnterpriseInfo: types.GET_ENTERPRISE_INFO,
        savePersonalInfo: types.SAVE_PERSONAL_INFO,
        saveEnterpriseInfo: types.SAVE_ENTERPRISE_INFO,
        saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
        setSuccessMessage: types.SET_SUCCESS_MESSAGE
      }),
      goBack () {
        this.saveApplyLoanProgress({
          router: this.$router,
          token: this.userInfo.token,
          id: this.$route.query.applyLoanId,
          step: 1
        }).then((res) => {
          const resData = res.data
          if (Number(resData.code) === 0) {
//            if (`${this.$route.query.isEdit}` === 'true') {
            this.$router.push({
              path: `/applyLoan/${this.$route.params.id}/step1_xd`,
              query: {
                applyLoanId: this.$route.query.applyLoanId,
                isEdit: true
              }
            })
//            } else {
//              this.$router.go(-1)
//            }
          }
        })
      },
      submitForm () {
        // 第一步为添加，第二步开始，保存后调用更新项目进度接口
        this.$refs.step2Form.validate((valid) => {
          if (valid) {
            this.isSubmitting = true
            if (this.userInfo.crmCustomerType === '1') {
              // 个人
              this.saveApplyLoanProgress({
                router: this.$router,
                token: this.userInfo.token,
                id: this.$route.query.applyLoanId,
                step: 2
              }).then((res) => {
                const resData = res.data
                if (Number(resData.code) === 0) {
                  this.isSubmitting = false
                  this.$router.push({
                    path: `/applyLoan/${this.$route.params.id}/step3_xd`,
                    query: {
                      applyLoanId: this.$route.query.applyLoanId,
                      isEdit: this.$route.query.isEdit
                    }
                  })
                }
              })
              // this.savePersonalInfo({
              //   router: this.$router,
              //   token: this.userInfo.token,
              //   customerId: this.userInfo.crmCustomerId,
              //   customerName: this.step2Form.realName,
              //   personIdentityCard: this.step2Form.IDCardNum,
              //   personMobile: this.step2Form.cellphone
              // }).then((saveRes) => {
              //   if (Number(saveRes.data.code) === 0) {
              //     this.saveApplyLoanProgress({
              //       router: this.$router,
              //       token: this.userInfo.token,
              //       id: this.$route.query.applyLoanId,
              //       step: 2
              //     }).then((res) => {
              //       const resData = res.data
              //       if (Number(resData.code) === 0) {
              //         this.isSubmitting = false
              //         this.$router.push({
              //           path: `/applyLoan/${this.$route.params.id}/step3`,
              //           query: {
              //             applyLoanId: this.$route.query.applyLoanId,
              //             isEdit: this.$route.query.isEdit
              //           }
              //         })
              //       }
              //     })
              //   }
              // })
            } else {
              // 企业
              this.saveEnterpriseInfo({
                router: this.$router,
                token: this.userInfo.token,
                customerId: this.userInfo.crmCustomerId,
                customerName: this.step2FormEnterprise.customerName,
                enterpriseNumber: this.step2FormEnterprise.enterpriseNumber,
                enterprisePartnerNumber: this.step2FormEnterprise.enterprisePartnerNumber,
                enterpriseRegAddr: this.step2FormEnterprise.enterpriseRegAddr,
                enterpriseType: this.step2FormEnterprise.enterpriseType,
                enterpriseRegMoney: this.step2FormEnterprise.enterpriseRegMoney,
                enterpriseLegalUser: this.step2FormEnterprise.enterpriseLegalUser,
                enterpriseLegalIdNo: this.step2FormEnterprise.enterpriseLegalIdNo,
                enterpriseLegalUserPhone: this.step2FormEnterprise.enterpriseLegalUserPhone,
                enterpriseOrganizingNumber: this.step2FormEnterprise.enterpriseOrganizingNumber,
                enterpriseScale: this.step2FormEnterprise.enterpriseScale,
                enterpriseNationalNumber: this.step2FormEnterprise.enterpriseNationalNumber,
                enterpriseGovernmentNumber: this.step2FormEnterprise.enterpriseGovernmentNumber,
                enterpriseRegOrgan: this.step2FormEnterprise.enterpriseRegOrgan,
                enterpriseEmployeeNum: this.step2FormEnterprise.enterpriseEmployeeNum,
                enterpriseScope: this.step2FormEnterprise.enterpriseScope,
                enterpriseFoundExplain: this.step2FormEnterprise.enterpriseFoundExplain,
                userType: this.step2FormEnterprise.userType,
                registrationType: this.step2FormEnterprise.registrationType
              }).then((saveRes) => {
                if (Number(saveRes.data.code) === 0) {
                  this.saveApplyLoanProgress({
                    router: this.$router,
                    token: this.userInfo.token,
                    id: this.$route.query.applyLoanId,
                    step: 2
                  }).then((res) => {
                    const resData = res.data
                    if (Number(resData.code) === 0) {
                      this.isSubmitting = false
                      this.$router.push({
                        path: `/applyLoan/${this.$route.params.id}/step3_xd`,
                        query: {
                          applyLoanId: this.$route.query.applyLoanId,
                          isEdit: this.$route.query.isEdit
                        }
                      })
                    }
                  })
                }
              })
            }
          } else {
            return false
          }
        })
      }
    },
//    beforeRouteLeave (to, from, next) {
//      if (to.fullPath.indexOf('step1') !== -1) {
//        this.goBack(next)
//      } else if (to.fullPath.indexOf('step3') !== -1) {
//        this.submitForm(next)
//      }
//    },
    mounted () {
      this.$store.commit('changeActive', 2);
      if (this.userInfo.crmCustomerType === '1') {
        // 个人
        this.getPersonalInfo({
          router: this.$router,
          token: this.userInfo.token,
          customerId: this.userInfo.crmCustomerId
        }).then((res) => {
          if (Number(res.data.code) === 0) {
            const data = res.data.data
            this.isEditable = Number(data.isEditable)
            this.step2Form = {
              realName: (data.customerName != null ? data.customerName : ''),
              IDCardNum: data.personIdentityCard,
              cellphone: data.mobile
            }
          }
        })
      } else {
        // 企业
        this.getEnterpriseInfo({
          router: this.$router,
          token: this.userInfo.token,
          customerId: this.userInfo.crmCustomerId
        }).then((res) => {
          if (Number(res.data.code) === 0) {
            const data = res.data
            this.isEditable = Number(data.isEditable)
            this.step2FormEnterprise = {
              customerName: (data.customerName != null ? data.customerName : ''),
              enterpriseNumber: (data.crmCustomerEnterprise.enterpriseNumber != null ? data.crmCustomerEnterprise.enterpriseNumber : ''),
              enterprisePartnerNumber: (data.crmCustomerEnterprise.enterprisePartnerNumber != null ? data.crmCustomerEnterprise.enterprisePartnerNumber : ''),
              enterpriseRegAddr: (data.crmCustomerEnterprise.enterpriseRegAddr != null ? data.crmCustomerEnterprise.enterpriseRegAddr : ''),
              enterpriseType: (data.crmCustomerEnterprise.enterpriseType != null ? data.crmCustomerEnterprise.enterpriseType : ''),
              enterpriseRegMoney: (data.crmCustomerEnterprise.enterpriseRegMoney != null ? data.crmCustomerEnterprise.enterpriseRegMoney : ''),
              enterpriseLegalUser: (data.crmCustomerEnterprise.enterpriseLegalUser != null ? data.crmCustomerEnterprise.enterpriseLegalUser : ''),
              enterpriseLegalIdNo: (data.crmCustomerEnterprise.enterpriseLegalIdNo != null ? data.crmCustomerEnterprise.enterpriseLegalIdNo : ''),
              enterpriseLegalUserPhone: (data.crmCustomerEnterprise.enterpriseLegalUserPhone != null ? data.crmCustomerEnterprise.enterpriseLegalUserPhone : ''),
              enterpriseOrganizingNumber: (data.crmCustomerEnterprise.enterpriseOrganizingNumber != null ? data.crmCustomerEnterprise.enterpriseOrganizingNumber : ''),
              enterpriseScale: (data.crmCustomerEnterprise.enterpriseScale != null ? data.crmCustomerEnterprise.enterpriseScale : ''),
              enterpriseNationalNumber: (data.crmCustomerEnterprise.enterpriseNationalNumber != null ? data.crmCustomerEnterprise.enterpriseNationalNumber : ''),
              enterpriseGovernmentNumber: (data.crmCustomerEnterprise.enterpriseGovernmentNumber != null ? data.crmCustomerEnterprise.enterpriseGovernmentNumber : ''),
              enterpriseRegOrgan: (data.crmCustomerEnterprise.enterpriseRegOrgan != null ? data.crmCustomerEnterprise.enterpriseRegOrgan : ''),
              enterpriseEmployeeNum: (data.crmCustomerEnterprise.enterpriseEmployeeNum != null ? data.crmCustomerEnterprise.enterpriseEmployeeNum : ''),
              enterpriseScope: (data.crmCustomerEnterprise.enterpriseScope != null ? data.crmCustomerEnterprise.enterpriseScope : ''),
              enterpriseFoundExplain: (data.crmCustomerEnterprise.enterpriseFoundExplain != null ? data.crmCustomerEnterprise.enterpriseFoundExplain : ''),
              enterpriseScaleArray: (data.enterpriseScaleArray != null ? data.enterpriseScaleArray : ''),
              enterpriseTypeArray: (data.enterpriseTypeArray != null ? data.enterpriseTypeArray : ''),
              userType: (data.crmCustomerEnterprise.userType != null ? Number(data.crmCustomerEnterprise.userType) : 2),
              registrationType: (data.crmCustomerEnterprise.registrationType != null ? Number(data.crmCustomerEnterprise.registrationType) : 0)
            }
          }
        })
      }
    }
  }
</script>
<style lang="scss">
  .el-input.is-disabled .el-input__inner {
    background: #f7f7f7;
  }

  .step1-form .step-form__title {
    padding-bottom: 70px;
  }
</style>



// WEBPACK FOOTER //
// Step2_bak.vue?6785875d